import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-world-record',
  templateUrl: './world-record.component.html',
  styleUrls: ['./world-record.component.scss']
})
export class WorldRecordComponent implements OnInit {

  recordImages = [
    '/assets/img/quick-links/world-record/1.jpg',
    '/assets/img/quick-links/world-record/2.jpg',
    '/assets/img/quick-links/world-record/3.jpg',
    '/assets/img/quick-links/world-record/4.jpg',
  ];

  constructor() { }

  ngOnInit(): void { }

}
